import Vue from 'vue';
import Vuex from 'vuex';

import oAuth from '@/store/oAuth';
import $http from '@/module/http';
import app from '@/store/app';
import bss from '@/store/bss';
import oss from '@/store/oss';
import cms from '@/store/cms';
import dbm from '@/store/dbm';
import bmr from '@/store/bmr';
import oms from '@/store/oms';

Vue.use(Vuex);

let agents = null;
// 缓存原始部门数据，所有部门相关 action 共享同一次接口请求
let all_departments_p = null;
let departments_p = null;
let user_departments_p = null;

export default new Vuex.Store({
  state: {
    departments: [],
    userDepartments: [],
    drawer: null,
    topLoading: false,
    innerGroups: []
  },
  mutations: {
    toggleDrawer(state) {
      state.drawer = !state.drawer;
    },
    setState(state, data) {
      let payload = data.payload;
      let changeState = (module, state) => {
        if (!module) {
          let keys = Object.keys(payload);
          keys.map((k) => (state[k] = payload[k]));
        } else {
          let arr = module.split('/');
          let keys = Object.keys(payload);
          let st = state;
          if (arr.length === 1) {
            st = state[arr[0]];
          } else {
            for (let i = 0; i < arr.length; i++) {
              st = st[arr[i]];
            }
          }
          keys.map((k) => (st[k] = payload[k]));
        }
      };
      changeState(data.module, state);
    },
    toggleLoading(state, isLoading = false) {
      if (state.topLoading === isLoading) {
        return;
      }
      state.topLoading = isLoading;
    }
  },
  actions: {
    getAgents: () => {
      if (!agents) {
        agents = $http
          .get(`users/options/?q=is_active=1`, { params: { page_size: 500 } })
          .then(({ results }) => {
            return Promise.resolve(results);
          })
          .catch((e) => {
            // 请求失败后允许下次重试，不能把失败结果一直缓存为 User 选项。
            agents = null;
            Vue.prototype.$message.error({
              content: e.detail,
              duration: 0,
              closable: true
            });
            return [];
          });
      }
      return Promise.resolve(agents);
    },
    // 获取原始部门列表（仅调一次接口，结果被 getDepartments 和 getUserDepartments 共享）
    _fetchAllDepartments: () => {
      if (!all_departments_p) {
        all_departments_p = $http
          .get(`departments/`)
          .then(({ results }) => results)
          .catch((e) => {
            Vue.prototype.$message.error({
              content: e.detail,
              duration: 0,
              closable: true
            });
          });
      }
      return all_departments_p;
    },
    // ticket 相关部门，排除 Operation Department和R&D Department
    getDepartments: ({ dispatch, commit }) => {
      if (!departments_p) {
        departments_p = dispatch('_fetchAllDepartments').then((results) => {
          const filtered = results.filter(
            (item) => item.name !== 'Operation Department' && item.name !== 'R&D Department'
          );
          commit('setState', { payload: { departments: filtered } });
          return filtered;
        });
      }
      return departments_p;
    },
    // 用户部门，排除 Sales Department 和 Billing Department
    getUserDepartments: ({ dispatch, commit }) => {
      if (!user_departments_p) {
        user_departments_p = dispatch('_fetchAllDepartments').then((results) => {
          const filtered = results.filter(
            (item) => item.name !== 'Sales Department' && item.name !== 'Billing Department'
          );
          commit('setState', { payload: { userDepartments: filtered } });
          return filtered;
        });
      }
      return user_departments_p;
    },
    getInnerGroups: ({ commit }) => {
      return $http
        .get(`inner_groups/`)
        .then(({ results }) => {
          commit('setState', { payload: { innerGroups: results } });
          return results;
        })
        .catch((e) => {
          Vue.prototype.$message.error({
            content: e.detail,
            duration: 0,
            closable: true
          });
        });
    }
  },
  modules: {
    oAuth,
    app,
    bss,
    oss,
    cms,
    dbm,
    bmr,
    oms
  }
});
